/**
 * The person slice.
 *
 * Not a face: `entries/` is one domain with one production face (ADR 0014:114-116). This index is
 * for the domain face and the sibling slices.
 *
 * **Eleven of the twelve files under `app/app/people/` were not route files** — eight components,
 * the wrapper, the client page, and a constants module — which is the colocation ADR 0010 rules
 * out: a file Next.js does not resolve by name owns nothing there. Only `page.tsx` stays, and it
 * keeps its export and delegates its body.
 */

export type { ContactFrequency, PersonEntry, PersonMeta } from './meta'
export { CONTACT_FREQUENCY_OPTIONS } from './meta'
export { isPersonEntry } from './guard'
export type { PersonCategory } from './category-colors'
export {
  CATEGORY_FILTERS,
  PERSON_AVATAR_COLORS,
  PERSON_CATEGORY_COLORS,
  PERSON_CATEGORY_LABELS,
} from './category-colors'

export { useCreatePerson, useUpdatePerson, useDeletePerson } from './write-spec'

export type { PersonWithLastInteraction } from './select-people'
export {
  peopleQueryKey,
  personEntriesQueryKey,
  usePeopleData,
  usePersonEntries,
  usePrefetchPeople,
  usePrefetchPersonEntries,
  useInvalidatePeopleData,
  useInvalidatePersonEntries,
} from './select-people'

export { PeopleWrapper } from './people-wrapper'
export { PeoplePageClient } from './page-client'
export { PersonRow } from './PersonRow'
export { PersonDetailPanel } from './PersonDetailPanel'
export type { TimelineEntry } from './EntriesTimeline'
export { EntriesTimeline } from './EntriesTimeline'
export { AddPersonDialog, useAddPersonDialog } from './add-person-dialog'
export { EditPersonDialog } from './edit-person-dialog'
export { ContactFrequencySelector } from './contact-frequency-selector'
